export const GET_ERRORS = 'GET_ERRORS';
export const VRATI_DOKUMENT = 'VRATI_DOKUMENT';
export const UKLONI_DOKUMENT = 'UKLONI_DOKUMENT';

//USER
export const ADD_USER = 'ADD_USER';
export const ADD_USER_START = 'ADD_USER_START';
export const ADD_USER_ERROR = 'ADD_USER_ERROR';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_START = 'UPDATE_USER_START';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const GET_USER = 'GET_USER';
export const GET_USER_START = 'GET_USER_START';
export const GET_USER_ERROR = 'GET_USER_ERROR';

export const GET_USER_LIST = 'GET_USER_LIST';
export const GET_USER_LIST_START = 'GET_USER_LIST_START';
export const GET_USER_LIST_ERROR = 'GET_USER_LIST_ERROR';
export const GET_USER_LIST_PAGEABLE = 'GET_USER_LIST_PAGEABLE';

export const DEACTIVATE_USER = 'DEACTIVATE_USER';
export const DEACTIVATE_USER_START = 'DEACTIVATE_USER_START';
export const DEACTIVATE_USER_ERROR = 'DEACTIVATE_USER_ERROR';

export const ACTIVATE_USER = 'ACTIVATE_USER';
export const ACTIVATE_USER_START = 'ACTIVATE_USER_START';
export const ACTIVATE_USER_ERROR = 'ACTIVATE_USER_ERROR';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_START = 'DELETE_USER_START';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_START = 'SET_CURRENT_USER_START';
export const SET_CURRENT_USER_ERROR = 'SET_CURRENT_USER_ERROR';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_START = 'CHANGE_PASSWORD_START';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const ADD_USER_REGISTRATION = 'ADD_USER_REGISTRATION';
export const ADD_USER_REGISTRATION_START = 'ADD_USER_REGISTRATION_START';
export const ADD_USER_REGISTRATION_ERROR = 'ADD_USER_REGISTRATION_ERROR';

//user whit signature
export const UPDATE_USER_WITH_SIGNATURE = 'UPDATE_USER_WITH_SIGNATURE';
export const UPDATE_USER_WITH_SIGNATURE_START = 'UPDATE_USER_WITH_SIGNATURE_START';
export const UPDATE_USER_WITH_SIGNATURE_ERROR = 'UPDATE_USER_WITH_SIGNATURE_ERROR';

export const GET_USER_WITH_SIGNATURE = 'GET_USER_WITH_SIGNATURE';
export const GET_USER_WITH_SIGNATURE_START = 'GET_USER_WITH_SIGNATURE_START';
export const GET_USER_WITH_SIGNATURE_ERROR = 'GET_USER_WITH_SIGNATURE_ERROR';

export const CLEAR_ERROR_USER = 'CLEAR_ERROR_USER';
export const CLEAR_ERROR_LOGIN = 'CLEAR_ERROR_LOGIN';

//USER ROLE
export const ADD_USER_ROLE = 'ADD_USER_ROLE';
export const ADD_USER_ROLE_START = 'ADD_USER_ROLE_START';
export const ADD_USER_ROLE_ERROR = 'ADD_USER_ROLE_ERROR';

export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const UPDATE_USER_ROLE_START = 'UPDATE_USER_ROLE_START';
export const UPDATE_USER_ROLE_ERROR = 'UPDATE_USER_ROLE_ERROR';

export const GET_USER_ROLE = 'GET_USER_ROLE';
export const GET_USER_ROLE_START = 'GET_USER_ROLE_START';
export const GET_USER_ROLE_ERROR = 'GET_USER_ROLE_ERROR';

export const GET_USER_ROLE_LIST = 'GET_USER_ROLE_LIST';
export const GET_USER_ROLE_LIST_START = 'GET_USER_ROLE_LIST_START';
export const GET_USER_ROLE_LIST_ERROR = 'GET_USER_ROLE_LIST_ERROR';

export const GET_USER_ROLE_LIST_PAGEABLE = 'GET_USER_ROLE_LIST_PAGEABLE';
export const GET_USER_ROLE_LIST_PAGEABLE_START =
  'GET_USER_ROLE_LIST_PAGEABLE_START';
export const GET_USER_ROLE_LIST_PAGEABLE_ERROR =
  'GET_USER_ROLE_LIST_PAGEABLE_ERROR';

export const DELETE_USER_ROLE = 'DELETE_USER_ROLE';
export const DELETE_USER_ROLE_START = 'DELETE_USER_ROLE_START';
export const DELETE_USER_ROLE_ERROR = 'DELETE_USER_ROLE_ERROR';

export const CLEAR_ERROR_USER_ROLE = 'CLEAR_ERROR_USER_ROLE';

//BRAND
export const ADD_BRAND = 'ADD_BRAND';
export const ADD_BRAND_START = 'ADD_BRAND_START';
export const ADD_BRAND_ERROR = 'ADD_BRAND_ERROR';

export const UPDATE_BRAND = 'UPDATE_BRAND';
export const UPDATE_BRAND_START = 'UPDATE_BRAND_START';
export const UPDATE_BRAND_ERROR = 'UPDATE_BRAND_ERROR';

export const GET_BRAND = 'GET_BRAND';
export const GET_BRAND_START = 'GET_BRAND_START';
export const GET_BRAND_ERROR = 'GET_BRAND_ERROR';

export const GET_BRAND_LIST = 'GET_BRAND_LIST';
export const GET_BRAND_LIST_START = 'GET_BRAND_LIST_START';
export const GET_BRAND_LIST_ERROR = 'GET_BRAND_LIST_ERROR';

export const GET_BRAND_LIST_PAGEABLE = 'GET_BRAND_LIST_PAGEABLE';
export const GET_BRAND_LIST_PAGEABLE_START =
  'GET_BRAND_LIST_PAGEABLE_START';
export const GET_BRAND_LIST_PAGEABLE_ERROR =
  'GET_BRAND_LIST_PAGEABLE_ERROR';

export const DELETE_BRAND = 'DELETE_BRAND';
export const DELETE_BRAND_START = 'DELETE_BRAND_START';
export const DELETE_BRAND_ERROR = 'DELETE_BRAND_ERROR';

export const CLEAR_ERROR_BRAND = 'CLEAR_ERROR_BRAND';

//Vehicle Model
export const ADD_VEHICLE_MODEL= 'ADD_VEHICLE_MODEL';
export const ADD_VEHICLE_MODEL_START = 'ADD_VEHICLE_MODEL_START';
export const ADD_VEHICLE_MODEL_ERROR = 'ADD_VEHICLE_MODEL_ERROR';

export const UPDATE_VEHICLE_MODEL = 'UPDATE_VEHICLE_MODEL';
export const UPDATE_VEHICLE_MODEL_START = 'UPDATE_VEHICLE_MODEL_START';
export const UPDATE_VEHICLE_MODEL_ERROR = 'UPDATE_VEHICLE_MODEL_ERROR';

export const GET_VEHICLE_MODEL = 'GET_VEHICLE_MODEL';
export const GET_VEHICLE_MODEL_START = 'GET_VEHICLE_MODEL_START';
export const GET_VEHICLE_MODEL_ERROR = 'GET_VEHICLE_MODEL_ERROR';

export const GET_VEHICLE_MODEL_LIST = 'GET_VEHICLE_MODEL_LIST';
export const GET_VEHICLE_MODEL_LIST_START = 'GET_VEHICLE_MODEL_LIST_START';
export const GET_VEHICLE_MODEL_LIST_ERROR = 'GET_VEHICLE_MODEL_LIST_ERROR';

export const GET_VEHICLE_MODEL_LIST_PAGEABLE = 'GET_VEHICLE_MODEL_LIST_PAGEABLE';
export const GET_VEHICLE_MODEL_LIST_PAGEABLE_START =
  'GET_VEHICLE_MODEL_LIST_PAGEABLE_START';
export const GET_VEHICLE_MODEL_LIST_PAGEABLE_ERROR =
  'GET_VEHICLE_MODEL_LIST_PAGEABLE_ERROR';

export const DELETE_VEHICLE_MODEL = 'DELETE_VEHICLE_MODEL';
export const DELETE_VEHICLE_MODEL_START = 'DELETE_VEHICLE_MODEL_START';
export const DELETE_VEHICLE_MODEL_ERROR = 'DELETE_VEHICLE_MODEL_ERROR';

export const GET_VEHICLE_MODEL_BY_BRAND_ID = 'GET_VEHICLE_MODEL_BY_BRAND_ID';
export const  GET_VEHICLE_MODEL_BY_BRAND_ID_START = 'GET_VEHICLE_MODEL_BY_BRAND_ID_START';
export const  GET_VEHICLE_MODEL_BY_BRAND_ID_ERROR = 'GET_VEHICLE_MODEL_BY_BRAND_ID_ERROR';

export const CLEAR_ERROR_VEHICLE_MODEL = 'CLEAR_ERROR_VEHICLE_MODEL';



//VEHICLE
export const ADD_VEHICLE ='ADD_VEHICLE';
export const ADD_VEHICLE_START = 'ADD_VEHICLE_START';
export const ADD_VEHICLE_ERROR = 'ADD_VEHICLE_ERROR';

export const UPDATE_VEHICLE = 'UPDATE_VEHICLE_TYPE';
export const UPDATE_VEHICLE_START = 'UPDATE_VEHICLE_START';
export const UPDATE_VEHICLE_ERROR = 'UPDATE_VEHICLE_ERROR';

export const GET_VEHICLE = 'GET_VEHICLE';
export const GET_VEHICLE_START = 'GET_VEHICLE_START';
export const GET_VEHICLE_ERROR = 'GET_VEHICLE_ERROR';

export const GET_VEHICLE_LIST = 'GET_VEHICLE_LIST';
export const GET_VEHICLE_LIST_START = 'GET_VEHICLE_LIST_START';
export const GET_VEHICLE_LIST_ERROR = 'GET_VEHICLE_LIST_ERROR';

export const GET_VEHICLE_LIST_PAGEABLE = 'GET_VEHICLE_LIST_PAGEABLE';
export const GET_VEHICLE_LIST_PAGEABLE_START =
  'GET_VEHICLE_LIST_PAGEABLE_START';
export const GET_VEHICLE_LIST_PAGEABLE_ERROR =
  'GET_VEHICLE_LIST_PAGEABLE_ERROR';

export const DELETE_VEHICLE = 'DELETE_VEHICLE';
export const DELETE_VEHICLE_START = 'DELETE_VEHICLE_START';
export const DELETE_VEHICLE_ERROR = 'DELETE_VEHICLE_ERROR';

export const CLEAR_ERROR_VEHICLE = 'CLEAR_ERROR_VEHICLE';
//ProductCategory

export const ADD_PRODUCT_CATEGORY = 'ADD_PRODUCT_CATEGORY';
export const ADD_PRODUCT_CATEGORY_START = 'ADD_PRODUCT_CATEGORY_START';
export const ADD_PRODUCT_CATEGORY_ERROR = 'ADD_PRODUCT_CATEGORY_ERROR';

export const UPDATE_PRODUCT_CATEGORY = 'UPDATE_PRODUCT_CATEGORY';
export const UPDATE_PRODUCT_CATEGORY_START = 'UPDATE_PRODUCT_CATEGORY_START';
export const UPDATE_PRODUCT_CATEGORY_ERROR = 'UPDATE_PRODUCT_CATEGORY_ERROR';

export const GET_PRODUCT_CATEGORY = 'GET_PRODUCT_CATEGORY';
export const GET_PRODUCT_CATEGORY_START = 'GET_PRODUCT_CATEGORY_START';
export const GET_PRODUCT_CATEGORY_ERROR = 'GET_PRODUCT_CATEGORY_ERROR';

export const GET_PRODUCT_CATEGORY_LIST = 'GET_PRODUCT_CATEGORY_LIST';
export const GET_PRODUCT_CATEGORY_LIST_START= 'GET_PRODUCT_CATEGORY_LIST_START';
export const GET_PRODUCT_CATEGORY_LIST_ERROR = 'GET_PRODUCT_CATEGORY_LIST_ERROR';

export const GET_PRODUCT_CATEGORY_LIST_PAGEABLE = 'GET_PRODUCT_CATEGORY_LIST_PAGEABLE';
export const GET_PRODUCT_CATEGORY_LIST_PAGEABLE_START= 'GET_PRODUCT_CATEGORY_LIST_PAGEABLE_START';
export const GET_PRODUCT_CATEGORY_LIST_PAGEABLE_ERROR = 'GET_PRODUCT_CATEGORY_LIST_PAGEABLE_ERROR';

export const DELETE_PRODUCT_CATEGORY = 'DELETE_PRODUCT_CATEGORY';
export const DELETE_PRODUCT_CATEGORY_START = 'DELETE_PRODUCT_CATEGORY_START';
export const DELETE_PRODUCT_CATEGORY_ERROR = 'DELETE_PRODUCT_CATEGORY_ERROR';

export const CLEAR_ERROR_PRODUCT_CATEGORY = 'CLEAR_ERROR_PRODUCT_CATEGORY';


//Product
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_PRODUCT_START = 'ADD_PRODUCT_START';
export const ADD_PRODUCT_ERROR = 'ADD_PRODUCT_ERROR';

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const UPDATE_PRODUCT_START = 'UPDATE_PRODUCT_START';
export const UPDATE_PRODUCT_ERROR = 'UPDATE_PRODUCT_ERROR';

export const GET_PRODUCT= 'GET_PRODUCT_';
export const GET_PRODUCT_START = 'GET_PRODUCT_START';
export const GET_PRODUCT_ERROR = 'GET_PRODUCT_ERROR';

export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_PRODUCT_LIST_START= 'GET_PRODUCT_LIST_START';
export const GET_PRODUCT_LIST_ERROR = 'GET_PRODUCT_LIST_ERROR';

export const GET_PRODUCT_LIST_PAGEABLE = 'GET_PRODUCT_LIST_PAGEABLE';
export const GET_PRODUCT_LIST_PAGEABLE_START= 'GET_PRODUCT_LIST_PAGEABLE_START';
export const GET_PRODUCT_LIST_PAGEABLE_ERROR = 'GET_PRODUCT_LIST_PAGEABLE_ERROR';

export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const DELETE_PRODUCT_START = 'DELETE_PRODUCT_START';
export const DELETE_PRODUCT_ERROR = 'DELETE_PRODUCT_ERROR';

export const GET_PRODUCT_WITH_LOGO_START = "GET_PRODUCT_WITH_LOGO_START";
export const GET_PRODUCT_WITH_LOGO = "GET_PRODUCT_WITH_LOGO";
export const GET_PRODUCT_WITH_LOGO_ERROR = "GET_PRODUCT_WITH_LOGO_ERROR";

export const CLEAR_ERROR_PRODUCT = 'CLEAR_ERROR_PRODUCT';



//TravelOrder
export const ADD_TRAVEL_ORDER ='ADD_TRAVEL_ORDER';
export const ADD_TRAVEL_ORDER_START = 'ADD_TRAVEL_ORDER_START';
export const ADD_TRAVEL_ORDER_ERROR = 'ADD_TRAVEL_ORDER_ERROR';

export const UPDATE_TRAVEL_ORDER = 'UPDATE_TRAVEL_ORDER';
export const UPDATE_TRAVEL_ORDER_START = 'UPDATE_TRAVEL_ORDER_START';
export const UPDATE_TRAVEL_ORDER_ERROR = 'UPDATE_TRAVEL_ORDER_ERROR';

export const GET_TRAVEL_ORDER = 'GET_TRAVEL_ORDER';
export const GET_TRAVEL_ORDER_START = 'GET_TRAVEL_ORDER_START';
export const GET_TRAVEL_ORDER_ERROR = 'GET_TRAVEL_ORDER_ERROR';

export const GET_TRAVEL_ORDER_LIST = 'GET_TRAVEL_ORDER_LIST';
export const GET_TRAVEL_ORDER_LIST_START = 'GET_TRAVEL_ORDER_LIST_START';
export const GET_TRAVEL_ORDER_LIST_ERROR = 'GET_TRAVEL_ORDER_LIST_ERROR';

export const GET_TRAVEL_ORDER_LIST_PAGEABLE = 'GET_TRAVEL_ORDER_LIST_PAGEABLE';
export const GET_TRAVEL_ORDER_LIST_PAGEABLE_START =
  'GET_TRAVEL_ORDER_LIST_PAGEABLE_START';
export const GET_TRAVEL_ORDER_LIST_PAGEABLE_ERROR =
  'GET_TRAVEL_ORDER_LIST_PAGEABLE_ERROR';

export const DELETE_TRAVEL_ORDER = 'DELETE_TRAVEL_ORDER';
export const DELETE_TRAVEL_ORDER_START = 'DELETE_TRAVEL_ORDER_START';
export const DELETE_TRAVEL_ORDER_ERROR = 'DELETE_TRAVEL_ORDER_ERROR';

export const CLEAR_ERROR_TRAVEL_ORDER = 'CLEAR_ERROR_TRAVEL_ORDER';
